import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';

// REDUX
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getFixesState, setFixesState } from '@Managers/Redux/AppState/AppState';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { IReelSetsReel } from './ReelSets.types';

// STYLES
import styles from './ReelSets.scss';

// IMAGES
import arrow_up from './arrow_up.svg';
import arrow_down from './arrow_down.svg';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

const ReelSetsReel: React.FC<IReelSetsReel> = ({ reelIndex, reelStopIndex, reelSet, noOfSymbols }) => {
    const [state, setState] = useReducer(
        (state: { maxIndex: number; currentIndex: number; reelsData: Array<number> }, newState: {}) => ({ ...state, ...newState }),
        {
            maxIndex: 0,
            currentIndex: 0,
            reelsData: []
        }
    );

    const dispatch = useAppDispatch();
    const fixesState = useAppSelector(getFixesState);

    useEffect(() => {
        setState({ maxIndex: reelSet.length });
    }, []);

    useEffect(() => {
        let reels: Array<number> = [];
        let indexShift = reelStopIndex - 2;
        for (var i = 0; i < noOfSymbols; i++) {
            let index = indexShift + i;

            if (index < 0) index = reelSet.length + index;
            if (index >= state.maxIndex) index = index % reelSet.length;

            reels.push(reelSet[index]);
        }
        setState({
            currentIndex: reelStopIndex,
            reelsData: [...reels].reverse()
        });
    }, [reelStopIndex]);

    function shiftUp() {
        const newIndex = state.currentIndex - 1;
        if (newIndex >= 0) dispatch(setFixesState({ fixReelPosition: { ...fixesState.fixReelPosition, [reelIndex]: newIndex } }));
    }

    function shiftDown() {
        const newIndex = state.currentIndex + 1;
        if (newIndex <= state.maxIndex) dispatch(setFixesState({ fixReelPosition: { ...fixesState.fixReelPosition, [reelIndex]: newIndex } }));
    }

    return (
        <div className={styles.reel_sets_reel_container}>
            <div className={styles.reel_sets_reel_wrapper}>
                <div className={cn(styles.reel_sets_reel_button, styles.reel_sets_reel_button_up)} onClick={() => shiftUp()}>
                    <img src={arrow_up} />
                </div>
                <div className={styles.reel_sets_reel}>
                    {state.reelsData.map((e, index) => (
                        <div key={index} className={styles.reel_sets_reel_symbol}>
                            <div className={styles.reel_sets_reel_symbol_id}>ID: {e}</div>
                            <img
                                src={`${ConfigLoader.gameResourcePath}/bitmaps/ui/symbols/id_${e}.webp?v=${ConfigLoader.getConfiguration(EConfigurationNames.VERSION).cacheVersion}`}
                            />
                        </div>
                    ))}
                </div>
                <div className={cn(styles.reel_sets_reel_button, styles.reel_sets_reel_button_down)} onClick={() => shiftDown()}>
                    <img src={arrow_down} />
                </div>
            </div>
            <div className={styles.reel_sets_reel_set_range}>Range: 0 - {state.maxIndex}</div>
        </div>
    );
};

export default ReelSetsReel;
